import { MedicineBoxOutlined } from "@ant-design/icons";
import { bodyMapCore } from "./core/bodyMap";
import { defineWidget, type ConfiguratorSharedProps } from "../widgetDefinition";
import { bodyMapSlots } from "../Slots";
import { bodyMapDuplicate } from "../Duplication/bodyMap";
import { NoControlPanel } from "../widgetContract";
import { BodyMapInfo } from "../Info/bodyMap";
import type { BodyMapComponentSpec } from "../Processing/types";
import { BodyMapWidget } from "../WidgetComponents/BodyMapWidget";
import { BodyMapConfigurator } from "../AddWidgetModal/BodyMapConfigurator";
import { BINDABLE_SECTIONS } from "../Processing/controllerBindings";

export const bodyMapDefinition = defineWidget<BodyMapComponentSpec>({
  ...bodyMapCore,
  type: "body_map",
  dynamic: { bindableSections: BINDABLE_SECTIONS.body_map },
  slots: bodyMapSlots,
  duplicate: bodyMapDuplicate,
  controlPanel: NoControlPanel,
  info: { Content: BodyMapInfo },
  schema: ["display", "question_key", "queryId", "body_map_builder_misc"],
  contractHash: "0q1dv5udbld",

  template: {
    label: "Body Map",
    description: "Anatomical heat-map of athlete wellness and pain responses",
    icon: <MedicineBoxOutlined />,
  },

  defaultLayout: { w: 5, h: 13, minW: 5, minH: 13 },

  gridComponent: ({ id }) => <BodyMapWidget id={id} />,

  configurator: {
    modalTitle: "Body Map",
    wide: true,
    Component: BodyMapConfigurator as React.ComponentType<ConfiguratorSharedProps>,
  },
});
